module.exports = function($, gsap, ScrollTrigger, SplitType) {

    gsap.registerPlugin(ScrollTrigger);

    const t = new TimelineLite();

    let isDesktop = false;

    if( $(window).width() > 991 ){
        isDesktop = true;
    }


    if( isDesktop == true ){
        if( $('.home .two-columns-after-headband').length > 0 ) {
            t.from('.home .two-columns-after-headband .content', {
                scrollTrigger: {
                    trigger: ".two-columns-after-headband",
                    start: "top bottom",
                    end: "bottom bottom-=100",
                    scrub: 1,
                    immediateRender: false
                },
                x: "50%"
            })
            t.from('.home .two-columns-after-headband .wrapper-sidebar', {
                scrollTrigger: {
                    trigger: ".two-columns-after-headband",
                    start: "top bottom",
                    end: "bottom bottom-=100",
                    scrub: 1,
                    immediateRender: false
                },
                x: "-50%"
            })
        }
        if( $('.home .block.text-image2').length > 0 ){
            t.from(".home .block.text-image2 .text-image2--image img", {
                scrollTrigger: {
                    trigger: ".block.text-image2",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                x: "-50%"
            });
            t.from(".home .block.text-image2 .text-image2--picture img", {
                scrollTrigger: {
                    trigger: ".block.text-image2",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                x: "50%"
            });
            t.from(".home .block.text-image2 .text-image2--content .content", {
                scrollTrigger: {
                    trigger: ".block.text-image2",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                scale: "0.5"
            });
        }
        if( $('.home .block.interactive-map').length > 0 ){
            t.from(".home .block.interactive-map .map-container", {
                scrollTrigger: {
                    trigger: ".block.interactive-map",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                x: "100%"
            });

            t.from(".home .block.interactive-map .content", {
                scrollTrigger: {
                    trigger: ".block.interactive-map",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                x: "-100%"
            });
        }
        if( $('.home .block.text-image3').length > 0 ){
            t.from(".home .block.text-image3 .image", {
                scrollTrigger: {
                    trigger: ".block.text-image3",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                x: "-50%"
            });
            t.from(".home .block.text-image3 .content", {
                scrollTrigger: {
                    trigger: ".block.text-image3",
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                    immediateRender: false
                },
                x: "50%"
            });
        }
        if( $('.home .gallery').length > 0 ){
            ScrollTrigger.batch(".home .gallery .gallery__item", {
                onEnter: elements => {
                    gsap.from(elements, {
                        y: 100,
                        duration: 0.3,
                        stagger: 0.2
                    });
                }
            });
        }

        if( $("[animateText]").length ){
            let typeSplit = new SplitType('[animateText]', {
                types: 'lines, words, chars',
                tagName: 'span'
            });
            gsap.from('[animateText] .line', {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1,

                scrollTrigger: {
                    trigger: '[animateText]',
                    start: 'top bottom',

                }
            })
        }

    }







}
